"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  max-width: ", ";\n"], ["\n  max-width: ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactGridSystem = require("react-grid-system");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledRows = (0, _styledComponents2.default)(_reactGridSystem.Container)(_templateObject, function (props) {
  return props.width > 0 && props.width + "px !important";
});

var Rows = function Rows(props) {
  return _react2.default.createElement(StyledRows, props);
};

Rows.defaultProps = _propTypes.rowsDefaultProps;
Rows.propTypes = _propTypes.rowsPropTypes;
exports.default = Rows;